
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import InputPassword from '@/components/molecules/InputPassword.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'

/**
 * パスワード変更モーダルのフォーマット
 */
@Component({
  components: {
    ModalWindow,
    InputPassword,
    LabelBase,
    ButtonSubmit,
  },
})
export default class ModalPassword extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** 送信ボタンのDisabled制御 */
  @Prop()
  private submitDisabled!: (newPassword: string, confirm: string) => boolean

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** 新規パスワード */
  public newPassword = ''

  /** 確認用 */
  public confirm = ''

  /**
   * 送信ボタンのDisabled制御
   *   入力値の変更を検知するため、getterでラップする
   *
   * @returns パスワードか確認用パスワードが未入力ならtrue
   */
  private get disabled(): boolean {
    return this.submitDisabled(this.newPassword, this.confirm)
  }

  /**
   * モーダルを開く
   */
  public show(): void {
    this.newPassword = ''
    this.confirm = ''
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
